// HubsSettings
export const STALE_SUBMISSION_FORECAST = 'Sales:Forecast:StaleSubmission';
export const DEAL_SPLITS_ENABLED = 'Forecasting:DealSplits:Enabled';
export const FISCAL_OFFSET = 'hubspot:fiscalyear';
export const HAS_SETUP_FORECAST_CATEGORIES = 'Sales:Forecasting:HasSetupForecastCategories';

// User Attributes
export const HAS_SEEN_DEAL_STAGE_TOUR_SETTING = 'Sales:Forecasting:HasSeenDealStageForecastTour';
export const HAS_SEEN_DEAL_STAGE_FORECAST_TOUR = 'hasSeenDealStageForecastTour';
export const HAS_SEEN_FMO_MIGRATION_TOUR = 'hasSeenFmoMigrationTour';
export const HAS_SEEN_FMO_MIGRATION_TOUR_SETTING = 'Sales:Forecasting:HasSeenFmoMigrationTour';